import { Pin } from "lucide-react";
import { Announcement, api } from "../api";
import { koDate } from "../lib/format";
import { BlockRenderer, paragraph } from "./block-editor";
import { ModalFrame } from "./ui";

export function AnnouncementViewerModal({ announcement, draftPreview = false, onClose }: {
  announcement: Announcement;
  draftPreview?: boolean;
  onClose: () => void;
}) {
  const title = announcement.untrustedTitle.trim() || "제목 없는 공지";
  return <ModalFrame title={title} eyebrow={draftPreview ? "DRAFT PREVIEW" : "ANNOUNCEMENT"} wide onClose={onClose}>
    <article className="announcement-viewer-modal">
      <div className="announcement-viewer-meta">
        {draftPreview && <span className="announcement-status draft">임시저장</span>}
        {announcement.pinned && <span className="pill"><Pin size={11} /> 고정</span>}
        <time className="mono">{koDate(announcement.publishedAt || announcement.updatedAt)}</time>
      </div>
      <BlockRenderer
        blocks={announcement.blocks?.length ? announcement.blocks : [paragraph(announcement.untrustedBody)]}
        loadImage={api.downloadFile}
      />
    </article>
  </ModalFrame>;
}
